import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './LandingPage'
import { LanguageProvider } from './contexts/LanguageContext'
import './index.css'

// Lazy load components
const StudentProfile = React.lazy(() => import('./student-profile'))
const StudentReport = React.lazy(() => import('./Biology'))
const ChemistryAnalysisPlan = React.lazy(() => import('./chemistry'))
const EnglishAnalysisPlan = React.lazy(() => import('./english'))
const EnglishProficiencyReport = React.lazy(() => import('./language'))
const Ielts = React.lazy(() => import('./ielts'))
const Activity = React.lazy(() => import('./activity'))
const Alevel = React.lazy(() => import('./alevel'))
const AcademicProfile = React.lazy(() => import('./academic'))
const Chinese = React.lazy(() => import('./chinese'))
const Maths = React.lazy(() => import('./maths'))
const Business = React.lazy(() => import('./business'))
const Ict = React.lazy(() => import('./ict'))
const Global = React.lazy(() => import('./global'))
const Actionplan = React.lazy(() => import('./actionplan'))
const ActionplanCN = React.lazy(() => import('./actionplan_cn'))
const Layout = React.lazy(() => import('./Layout'))
const Layout2 = React.lazy(() => import('./Layout2'))
const Demo2StudentDashboard = React.lazy(() => import('./demo2-student-profile'))
const Demo2academic = React.lazy(() => import('./demo2-academic-performance'))
const Demo2english = React.lazy(() => import('./demo2-english'))
const Demo2ielts = React.lazy(() => import('./demo2-ielts'))
const Demo2activity = React.lazy(() => import('./demo2-activity'))
const Demo2actionplan = React.lazy(() => import('./demo2-actionplan'))
const Demo3StudentDashboard = React.lazy(() => import('./demo3-student-profile'))
const Demo3academic = React.lazy(() => import('./demo3-academic'))
const Layout3 = React.lazy(() => import('./Layout3'))
const Demo3activity = React.lazy(() => import('./demo3-activity'))
const Demo3sat = React.lazy(() => import('./demo3-sat-act-prep'))
const Demo3english = React.lazy(() => import('./demo3-english'))
const Demo3actionplan = React.lazy(() => import('./demo3-actionplan'))
const Demo3learnstyle = React.lazy(() => import('./demo3-learning-style'))
const Projectplan = React.lazy(() => import('./project-plan'))
const GauthQuestionPage = React.lazy(() => import('./question-demo'))
const Demo2activity2 = React.lazy(() => import('./demo2-activity2'))
const Demo3school = React.lazy(() => import('./demo3-school'))
const Demo3tutorplan = React.lazy(() => import('./demo3-tutor-plan'))
const Layout3_cn = React.lazy(() => import('./Layout3_cn'))
const Demo3StudentProfileCn = React.lazy(() => import('./demo3-student-profile-cn'))
const Demo3AcademicCn = React.lazy(() => import('./demo3-academic-cn'))
const Demo3SchoolCn = React.lazy(() => import('./demo3-schoo-cn'))
const Demo3satCn = React.lazy(() => import('./demo3-sat-act-prep-cn'))
const MITRoadmap = React.lazy(() => import('./demo3-activity-cn'))
const Demo3ActionplanCn = React.lazy(() => import('./demo3-actionplan-cn'))
const MITRoadmapCn = React.lazy(() => import('./demo3-mit-roadmap-cn'))
const ADPage = React.lazy(() => import('./ADPage'))
const ADPage2 = React.lazy(() => import('./ADPage2'))
const MapleLeafCup = React.lazy(() => import('./maple-leaf'))
const Demo4StudentProfile = React.lazy(() => import('./demo4-student-profile'))
const Layout4 = React.lazy(() => import('./Layout4'))
const Certificate = React.lazy(() => import('./certificate'))
const Demo4StudentProfile2 = React.lazy(() => import('./demo4-student-profile2'))
const Demo5StudentProfile = React.lazy(() => import('./demo5-student-profile-zh'))
const Demo6StudentProfile = React.lazy(() => import('./demo6-profile'))
const Demo4Academic = React.lazy(() => import('./demo4-academic'))
const Demo4PYP = React.lazy(() => import('./demo4-pyp'))
const MonthlyReport = React.lazy(() => import('./monthly-report'))
const InterestAnalysisReport = React.lazy(() => import('./demo4-asa'))
const Demo4Actionplan = React.lazy(() => import('./demo4-actionplan'))
const Demo4English = React.lazy(() => import('./demo4-english'))
const Intro = React.lazy(() => import('./intro'))
const AlphabetSpellingGame = React.lazy(() => import('./alphabet-spelling-game'))
const Demo3StudentProfileDynamic = React.lazy(() => import('./demo3-student-profile-dynamic'))
const Demo3AcademicDynamic = React.lazy(() => import('./demo3-academic-dynamic'))
const Demo7Profile = React.lazy(() => import('./demo7-profile'))
const Teacher = React.lazy(() => import('./teacher'))
const Demo3EnglishCn = React.lazy(() => import('./demo3-englis-cn'))
const Demo3StandardizedTestsCn = React.lazy(() => import('./demo3-standardized-tests-cn'))
const Demo4AcademicCn = React.lazy(() => import('./demo4-academic-cn'))
const Demo4ActionplanCn = React.lazy(() => import('./demo4-actionplan-cn'))
const Demo4AsaCn = React.lazy(() => import('./demo4-asa-cn'))
const Demo4StudentProfileCn = React.lazy(() => import('./demo4-student-profile-cn'))
const Demo4PypCn = React.lazy(() => import('./demo4-pyp-cn'))
const Demo4EnglishCn = React.lazy(() => import('./demo4-english-cn'))
const Layout4Cn = React.lazy(() => import('./Layout4_cn'))
const DemoK = React.lazy(() => import('./demo-k'))
const Demo3ApplicationStrategy = React.lazy(() => import('./demo3-application-strategy'))
const Demo3EmmaStrategy = React.lazy(() => import('./demo3-emma-strategy'))
const Demo4AmyElementary = React.lazy(() => import('./demo4-amy-elementary'))
const Demo3StandardizedTests = React.lazy(() => import('./demo3-standardized-tests'))
const ApplicationStrategyWrapper = React.lazy(() => import('./application-strategy-wrapper'))
const MiddleApplicationStrategy = React.lazy(() => import('./middle-application-strategy'))
const AdmissionProbabilityPage = React.lazy(() => import('./AdmissionProbabilityPage'))

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600"></div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <Router>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/project-plan" element={<Projectplan />} />
            <Route path="/question-demo" element={<GauthQuestionPage />} />
            <Route path="/mit-roadmap" element={<MITRoadmapCn />} />
            <Route path="/ad" element={<ADPage />} />
            <Route path="/ad2" element={<ADPage2 />} />
            <Route path="/maple-leaf" element={<MapleLeafCup />} />
            <Route path="/certificate" element={<Certificate />} />
            <Route path="/demo5" element={<Demo5StudentProfile />} />
            <Route path="/demo6" element={<Demo6StudentProfile />} />
            <Route path="/monthly-report" element={<MonthlyReport />} />
            <Route path="/intro" element={<Intro />} />
            <Route path="/alphabet-spelling-game" element={<AlphabetSpellingGame />} />
            <Route path="/demo7" element={<Demo7Profile />} />
            <Route path="/teacher" element={<Teacher />} />
            <Route path="/demok" element={<DemoK />} />
            <Route path="/amy-elementary" element={<Demo4AmyElementary />} />
            <Route path="/admission-probability" element={<AdmissionProbabilityPage />} />
            {/* 通用申请策略路由 - 动态加载学生数据 */}
            <Route path="/strategy/:studentName" element={<ApplicationStrategyWrapper />} />
            {/* 保留 middle-application-strategy 作为通用示例 */}
            <Route path="/middle-strategy" element={<MiddleApplicationStrategy />} />
            {/* Demo1 系列报告路由 */}
            <Route path="/dashboard" element={<Layout />}>
              <Route index element={<StudentProfile />} />
              <Route path="profile" element={<StudentProfile />} />
              <Route path="alevel" element={<Alevel />} />
              <Route path="academic" element={<AcademicProfile />} />
              <Route path="chinese" element={<Chinese />} />
              <Route path="maths" element={<Maths />} />
              <Route path="business" element={<Business />} />
              <Route path="ict" element={<Ict />} />
              <Route path="global" element={<Global />} />
              <Route path="biology" element={<StudentReport />} />
              <Route path="chemistry" element={<ChemistryAnalysisPlan />} />
              <Route path="english" element={<EnglishAnalysisPlan />} />
              <Route path="language" element={<EnglishProficiencyReport />} />
              <Route path="ielts" element={<Ielts />} />
              <Route path="activity" element={<Activity />} />
              <Route path="actionplan" element={<Actionplan />} />
              <Route path="actionplan_cn" element={<ActionplanCN />} />
            </Route>
            {/* Demo2 系列报告路由 */}
            <Route path="/dashboard/demo2" element={<Layout2 />}>
              <Route index element={<Demo2StudentDashboard />} />
              <Route path="academic" element={<Demo2academic />} />
              <Route path="english" element={<Demo2english />} />
              <Route path="ielts" element={<Demo2ielts />} />
              <Route path="activity" element={<Demo2activity />} />
              <Route path="actionplan" element={<Demo2actionplan />} />
              <Route path="activity2" element={<Demo2activity2 />} />
            </Route>
            {/* Demo3 系列报告路由 */}
            <Route path="/dashboard/demo3" element={<Layout3 />}>
              <Route index element={<Demo3StudentDashboard />} />
              <Route path="academic" element={<Demo3academic />} />
              <Route path="activity" element={<Demo3activity />} />
              <Route path="sat" element={<Demo3sat />} />
              <Route path="english" element={<Demo3english />} />
              <Route path="actionplan" element={<Demo3actionplan />} />
              <Route path='learnstyle' element={<Demo3learnstyle />} />
              <Route path='school' element={<Demo3school />} />
              <Route path='tutorplan' element={<Demo3tutorplan />} />
              <Route path='dynamic' element={<Demo3StudentProfileDynamic />} />
              <Route path='academic-dynamic' element={<Demo3AcademicDynamic />} />
              <Route path='application-strategy' element={<Demo3ApplicationStrategy />} />
              <Route path='emma-strategy' element={<Demo3EmmaStrategy />} />  {/* 添加这行 */}
              <Route path='tests' element={<Demo3StandardizedTests />} />
            </Route>
            <Route path='/dashboard/demo3-cn' element={<Layout3_cn />}>
              <Route index element={<Demo3StudentProfileCn />} />
              <Route path="academic" element={<Demo3AcademicCn />} />
              <Route path="activity" element={<MITRoadmap />} />
              <Route path="sat" element={<Demo3satCn />} />
              <Route path="actionplan" element={<Demo3ActionplanCn />} />
              <Route path="learnstyle" element={<Demo3learnstyle />} />
              <Route path="school" element={<Demo3SchoolCn />} />
              <Route path="tutorplan" element={<Demo3tutorplan />} />
              <Route path="english" element={<Demo3EnglishCn />} />
              <Route path="tests" element={<Demo3StandardizedTestsCn />} />
            </Route>
            {/* Demo4 系列报告路由 */}
            <Route path="/dashboard/demo4" element={<Layout4 />}>
              <Route index element={<Demo4StudentProfile />} />
              <Route path="profile" element={<Demo4StudentProfile2 />} />
              <Route path="academic" element={<Demo4Academic />} />
              <Route path="pyp" element={<Demo4PYP />} />
              <Route path="asa" element={<InterestAnalysisReport />} />
              <Route path="actionplan" element={<Demo4Actionplan />} />
              <Route path="english" element={<Demo4English />} />
            </Route>
            {/* Demo4 系列报告路由 - 中文 */}
            <Route path="/dashboard/demo4-cn" element={<Layout4Cn />}>
              <Route index element={<Demo4StudentProfileCn />} />
              <Route path="academic" element={<Demo4AcademicCn />} />
              <Route path="pyp" element={<Demo4PypCn />} />
              <Route path="asa" element={<Demo4AsaCn />} />
              <Route path="actionplan" element={<Demo4ActionplanCn />} />
              <Route path="english" element={<Demo4EnglishCn />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </LanguageProvider>
  </React.StrictMode>,
)
